import React from 'react';
import { useI18n } from '@oneaudi/i18n-context';
import { CookieConsentRequestContainer, CookieConsentRequestContent, } from '../styles/LocationFilter.styles';
import { trackClicks } from '../MAStracking';
import { useServicesContext } from '../../../context';
import { Text, Headline, TextButton, Icon, } from '@oneaudi/unified-web-components';
import styled from 'styled-components';
import { FilterContext } from '../FilterContext';
import { SYS_COLOR_SURFACE_NEUTRAL_600_LIGHT, SYS_SPACE_FIXED_200, ThemeProvider, } from '@oneaudi/unified-web-common';
import { useDesktopOrMobileView } from '../../../hooks';
export const CookieConsentRequest = ({ mapConsentButtonText, openConsentOverlay, setIsTwoClickOverlayOpened, showIcon = true, isMas, }) => {
    const trackingService = useServicesContext().getAdditionalService('audi-tracking-service');
    const requestHeadline = useI18n({
        id: `nemo.sc.filter.locationfilter.cookieConsentRequestDealerList.Headline`,
        defaultMessage: 'Please give us your consent',
    });
    const requestContent = useI18n({
        id: `nemo.sc.filter.locationfilter.cookieConsentRequestDealerList.Content`,
        defaultMessage: 'Please note that some content may not be available for use without consent. We therefore recommend that you give the necessary consent.',
    });
    const audiContentService = useServicesContext().getAdditionalService('audi-content-service');
    let { lightMode } = audiContentService.getContent().fields;
    const isMobile = useDesktopOrMobileView('767px') === 'mobile';
    const context = React.useContext(FilterContext);
    const { isPlpFlag } = context;
    if (isPlpFlag) {
        lightMode = true;
    }
    return (React.createElement(CookieConsentRequestContainer, { lightMode: lightMode, isMas: isMas },
        React.createElement(ThemeProvider, { theme: lightMode ? { name: 'light' } : { name: 'dark' } }, showIcon && React.createElement(StyledIcon, { name: "info-circle", size: "s", lightMode: lightMode, isMas: isMas })),
        React.createElement(CookieConsentRequestContent, { isMas: true },
            React.createElement(StyledHeadline, { tag: isMas ? 'h4' : 'h2', variant: { order: '4', type: 'headline', weight: 'normal' }, isMas: isMas, lightMode: lightMode }, requestHeadline),
            React.createElement(StyledText, { tag: "p", variant: {
                    order: '1',
                    style: 'normal',
                    type: 'copy',
                }, isMas: isMas, lightMode: lightMode }, requestContent),
            React.createElement(TextButton, { variant: "primary", size: "sm", onClick: () => {
                    openConsentOverlay();
                    setIsTwoClickOverlayOpened(true);
                    if (isMas) {
                        trackClicks(trackingService, 'mandatory area search - consent layer open click', mapConsentButtonText, 'button', '', '');
                    }
                }, isFullWidth: isMobile }, mapConsentButtonText))));
};
export default CookieConsentRequest;
const StyledIcon = styled((props) => React.createElement(Icon, Object.assign({}, props))) `
  padding-top: ${SYS_SPACE_FIXED_200};
  color: ${(props) => !props.lightMode && !props.isMas && SYS_COLOR_SURFACE_NEUTRAL_600_LIGHT};
`;
const StyledHeadline = styled((props) => React.createElement(Headline, Object.assign({}, props))) `
  color: ${(props) => !props.lightMode && !props.isMas && SYS_COLOR_SURFACE_NEUTRAL_600_LIGHT};
`;
const StyledText = styled((props) => React.createElement(Text, Object.assign({}, props))) `
  color: ${(props) => !props.lightMode && !props.isMas && SYS_COLOR_SURFACE_NEUTRAL_600_LIGHT};
`;
